import { ReferenceNumber } from '../../ReferenceNumber';

import { ParcelSchedulingError } from './ParcelSchedulingError';

export class ParcelSchedulingResponse {
  success?: boolean;
  referenceNumbers: ReferenceNumber[] = [];
  shipmentIds: number[] = [];
  errors: ParcelSchedulingError[] = [];

  constructor(opts?: Partial<ParcelSchedulingResponse>) {
    if (opts?.success != null) {
      this.success = opts.success;
    }
    if (opts?.referenceNumbers != null) {
      this.referenceNumbers = opts.referenceNumbers.map(
        (val) => new ReferenceNumber(val),
      );
    }
    if (opts?.shipmentIds != null) {
      this.shipmentIds = [...opts.shipmentIds];
    }
    if (opts?.errors != null) {
      this.errors = opts.errors.map((val) => new ParcelSchedulingError(val));
    }
  }
}
